import { Badge, cn } from "@workspace/frontend-ui";
import { cva } from "class-variance-authority";
import type { FC, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  tone?: "glass" | "soft";
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}>;

const pillVariants = cva(
  "gap-1.5 rounded-full border-0 border-t font-semibold text-foreground backdrop-blur-md [&>img]:m-0 [&>img]:size-4 [&>svg]:size-4!",
  {
    variants: {
      tone: {
        glass: "border-t-foreground/10 bg-foreground/10",
        soft: "border-t-foreground/5 bg-foreground/5",
      },
      size: {
        sm: "h-6.5 px-2.5 text-xs has-[>img]:pl-1.5",
        md: "h-7 pr-2 pl-1.5 text-xs",
        lg: "h-8 px-3 text-sm has-[>img]:pr-2.5 has-[>img]:pl-1.5",
        xl: "h-8 pr-2.5 pl-1.5 text-base",
      },
    },
    defaultVariants: { tone: "glass", size: "sm" },
  },
);

const Pill: FC<Props> = ({ tone, size, className, children }) => (
  <Badge
    variant="secondary"
    data-slot="pill"
    className={cn(pillVariants({ tone, size }), className)}
  >
    {children}
  </Badge>
);

export default Pill;
